import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Button } from '@mui/material'
import { CustomModalContext } from 'common/contexts/CustomModalContext'
import { useContext } from 'react'
import ExpenseModal from './ExpenseModal'

const AddExpenseButton = ({ id_hoja, updateState, showButton = true, fechaInicio, fechaFin }) => {
  const { handleModal } = useContext(CustomModalContext)

  const openModal = () => {
    handleModal({
      closable: true,
      content: (
        <ExpenseModal
          id_hoja={id_hoja}
          updateState={updateState}
          fechaInicio={fechaInicio}
          fechaFin={fechaFin}
        />
      ),
    })
  }

  return (
    <>
      {showButton ? (
        <Button
          startIcon={<AddCircleIcon />}
          variant="contained"
          color="success"
          onClick={openModal}
        >
          Añadir Gasto
        </Button>
      ) : (
        <></>
      )}
    </>
  )
}

export default AddExpenseButton
